import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 16px 24px;
`;

export const ContentTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Title = styled.p`
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 21.78px;
  letter-spacing: -0.01em;
  text-align: left;
`;

export const Subtitle = styled.p`
  font-family: Inter;
  font-size: 14px;
  text-align: start;
`;

export const Row: any = styled.div`
  display: flex;
  gap: 32px;
  align-items: flex-end;
`;

export const Column = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
`;

export const Button = styled.button`
  font-family: Inter;
  gap: 12px;
  display: flex;
  align-items: center;
  height: 40px;
  padding: 10px;
  background-color: #0d6efd;
  border-radius: 8px;
  color: #ffffff;
  border: none;
  cursor: pointer;
  :disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
